export const FIRM_DOCUMENT_EDIT_DIALOG_TEST_IDS = {
  closeButton: 'firm-document-edit-dialog-close',
  cancelButton: 'firm-document-edit-dialog-cancel',
  dialog: 'firm-document-edit-dialog',
  documentNameInput: 'firm-document-edit-dialog-name',
  referenceClear: 'firm-document-edit-dialog-reference-clear',
  referenceMenu: 'firm-document-edit-dialog-reference-menu',
  referenceOption: (value: string) => `firm-document-edit-dialog-reference-${value}`,
  referenceSearch: 'firm-document-edit-dialog-reference-search',
  referenceSelect: 'firm-document-edit-dialog-reference-select',
  referenceSelectedOption: (value: string) => `firm-document-edit-dialog-reference-selected-${value}`,
  requestMenu: 'firm-document-edit-dialog-request-menu',
  requestOption: (id: number) => `firm-document-edit-dialog-request-${id}`,
  requestSearch: 'firm-document-edit-dialog-request-search',
  requestSelect: 'firm-document-edit-dialog-request-select',
  requestSelectedOption: (id: number) => `firm-document-edit-dialog-request-selected-${id}`,
  saveButton: 'firm-document-edit-dialog-save',
} as const;
